import BLOG_POSTS from './generatedPosts';

const normalizeToken = (value) =>
  String(value || '')
    .toLowerCase()
    .trim();

export const getAllBlogPosts = () =>
  [...BLOG_POSTS].sort((a, b) => Date.parse(b.date || 0) - Date.parse(a.date || 0));

export const getBlogPostBySlug = (slug, posts = BLOG_POSTS) =>
  posts.find((post) => normalizeToken(post.slug) === normalizeToken(slug)) || null;

export const getBlogTagOptions = (posts = BLOG_POSTS) => {
  const tags = new Set();
  posts.forEach((post) => {
    (post.tags || []).forEach((tag) => {
      if (String(tag || '').trim()) tags.add(String(tag).trim());
    });
  });
  return Array.from(tags).sort((a, b) => a.localeCompare(b));
};

export const getRelatedBlogPosts = (post, posts = BLOG_POSTS, limit = 3) => {
  if (!post) return [];
  const postTags = new Set((post.tags || []).map((tag) => normalizeToken(tag)));
  if (!postTags.size) return [];
  return posts
    .filter((item) => item.slug !== post.slug)
    .map((item) => {
      const overlap = (item.tags || []).reduce(
        (count, tag) => (postTags.has(normalizeToken(tag)) ? count + 1 : count),
        0
      );
      return { ...item, overlap };
    })
    .filter((item) => item.overlap > 0)
    .sort((a, b) => b.overlap - a.overlap || Date.parse(b.date || 0) - Date.parse(a.date || 0))
    .slice(0, limit);
};
